import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TooltipWrapper = ({
  tooltipText,
  placement = "top",
  tooltipProps = {},
  children,
  ...rest
}) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip
          id={`tooltip-${tooltipText}`}
          style={{ fontSize: "12px", padding: "2px" }}
          {...tooltipProps}
        >
          {tooltipText}
        </Tooltip>
      }
      {...rest}
    >
      {children}
    </OverlayTrigger>
  );
};

export default TooltipWrapper;
